import { Component, Input } from '@angular/core';
import { WoFlashService } from './wo-flash.service';

@Component({
    selector: 'wo-flash',
    templateUrl: 'wo-flash.component.html',
    styleUrls: ['wo-flash.component.css'],
})
export class WoFlashComponent {
    @Input() block = 'main';
    errorPool: any = [];
    warningPool: string[] = [];
    successPool: string[] = [];

    constructor (private woFlash: WoFlashService) {
        woFlash.geFlashChange().subscribe((props) => { this.doRender(props); });
    }

    doRender (props: any) {
        const data = {
            errors: this.woFlash.errorMessages,
            success: this.woFlash.successMessages,
            warnings: this.woFlash.warningMessages,
        };

        this.errorPool = [];
        this.successPool = [];
        this.warningPool = [];

        if (props.block === this.block) {
            if (data && data['errors'] && data['errors'][0]) {
                this.errorPool = data['errors'];
            } else if (data && data['success'] && data['success'][0]) {
                this.successPool = data['success'];
            }

            if (data && data['warnings'] && data['warnings'][0]) {
                this.warningPool = data['warnings'];
            }
        }
    }

    doFlush() {
        this.errorPool = [];
        this.successPool = [];
        this.warningPool = [];
        this.woFlash.flush();
    }
}
